import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, pluck, publishReplay, refCount, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CustomTranslationService {
  // custom translations features configurable per country and language
  CUSTOM_TRANSLATIONS_FEATURES_CONFIG = '../../../public/features/CUSTOM_TRANSLATIONS_FEATURES.json';

  cacheWindowTime = 3600000;
  private cachedIsCustomTranslationsEnabled$: any = {};

  constructor(private http: HttpClient) {}

  getCustomTranslationsFeaturesConfig$(activeCountry: string): Observable<any> {
    if (!this.cachedIsCustomTranslationsEnabled$[activeCountry]) {
      this.cachedIsCustomTranslationsEnabled$[activeCountry] = this.http
        .get(this.CUSTOM_TRANSLATIONS_FEATURES_CONFIG)
        .pipe(publishReplay(1, this.cacheWindowTime), refCount(), take(1), catchError(this.errorHandler));
    }
    return this.cachedIsCustomTranslationsEnabled$[activeCountry];
  }

  isCustomTranslationsEnabled$(activeCountry: string, activeLanguage: string, customKeys: string[]): Observable<any> {
    const idString = [activeCountry, activeLanguage, customKeys.join('-')].join('-');
    if (!this.cachedIsCustomTranslationsEnabled$[idString]) {
      this.cachedIsCustomTranslationsEnabled$[idString] = this.getCustomTranslationsFeaturesConfig$(activeCountry).pipe(
        publishReplay(1, this.cacheWindowTime),
        refCount(),
        take(1),
        pluck('country'),
        map((data: any) => (data[activeCountry] !== undefined ? data[activeCountry] : data['default'])),
        pluck('language'),
        map((data) =>
          data[activeLanguage] !== undefined
            ? data[activeLanguage]['enabled'] && customKeys.every((ck) => data[activeLanguage].keys.includes(ck))
            : data['default']['enabled']
        ),
        catchError(this.errorHandler)
      );
    }
    return this.cachedIsCustomTranslationsEnabled$[idString];
  }

  errorHandler(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
